export const DuesGroupTypes = {
  SHOW_DUES_GROUP: 'SHOW_DUES_GROUP',
  ADD_DUES_GROUP: 'ADD_DUES_GROUP',
  UPDATE_DUES_GROUP: 'UPDATE_DUES_GROUP',
  DELETE_DUES_GROUP: 'DELETE_DUES_GROUP',
}
